export default "__VITE_ASSET__BrdiINEz__"